import React from 'react';
import { createPortal } from 'react-dom';
import './amplifierControl.css';

export interface AmplifierModalPortalProps {
  open: boolean;
  /** 编辑弹窗等需叠在选择弹窗之上时使用 */
  layer?: 'base' | 'elevated';
  onBackdropClick?: () => void;
  children: React.ReactNode;
}

export const AmplifierModalPortal: React.FC<AmplifierModalPortalProps> = ({
  open,
  layer = 'base',
  onBackdropClick,
  children,
}) => {
  if (!open || typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div
      className={`amplifier-modal-portal-root amplifier-modal-overlay amplifier-modal-overlay--${layer}`}
      onClick={onBackdropClick}
      role="presentation"
    >
      {children}
    </div>,
    document.body,
  );
};
